import { Navigate, Outlet, type RouteObject } from 'react-router-dom';
import { SmartFillBridgeProvider } from './bridge/context';
import type { SmartFillBridgeClient } from './bridge/client';
import { CaraMark } from './components/CaraMark';
import { SidebarBootstrap } from './sidebar/SidebarBootstrap';
import { BucketDetailView } from './views/BucketDetailView';
import { BucketsView } from './views/BucketsView';
import { SuperCopyView } from './views/SuperCopyView';
import { ThisPageView } from './views/ThisPageView';
import { WorkspacesView } from './views/WorkspacesView';
import { SettingsView } from './views/SettingsView';

export function App() {
  return <Outlet />;
}

export function DirectVisitState() {
  return (
    <main className="smartfill-app smartfill-app--direct">
      <section className="state-panel state-panel--direct" aria-labelledby="direct-visit-title">
        <div className="state-icon" aria-hidden="true">
          <CaraMark />
        </div>
        <h1 id="direct-visit-title">Open Smart Fill from the Cara browser extension</h1>
        <p>
          Smart Fill runs securely inside the extension sidebar while you work on insurance forms.
        </p>
      </section>
    </main>
  );
}

function EmbeddedBridgeRoute({ client }: { client?: SmartFillBridgeClient }) {
  return (
    <SmartFillBridgeProvider client={client}>
      <SidebarBootstrap />
    </SmartFillBridgeProvider>
  );
}

export function createSmartFillRoutes(client?: SmartFillBridgeClient): RouteObject[] {
  return [
    {
      path: '/',
      element: <App />,
      children: [
        {
          index: true,
          element: <DirectVisitState />
        },
        {
          path: 'extension',
          element: <EmbeddedBridgeRoute client={client} />,
          children: [
            {
              index: true,
              element: <ThisPageView />
            },
            {
              path: 'buckets',
              element: <BucketsView />
            },
            {
              path: 'buckets/super-copy',
              element: <SuperCopyView />
            },
            {
              path: 'buckets/:bucketId',
              element: <BucketDetailView />
            },
            {
              path: 'workspaces',
              element: <WorkspacesView />
            },
            {
              path: 'settings',
              element: <SettingsView />
            },
            {
              path: '*',
              element: <Navigate to="/extension" replace />
            }
          ]
        },
        {
          path: '*',
          element: <Navigate to="/" replace />
        }
      ]
    }
  ];
}

export const smartFillRoutes = createSmartFillRoutes();
